import React from 'react';
import { useTranslation } from 'react-i18next';
import Partners from './common/Partners';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="p-2.5  bg-white dark:bg-darkPanelBg">
      <Partners />
      <div className="px-3 py-5">
        <div>
          <img
            className="w-[240px] md:w-[300px] h-auto dark:hidden"
            src="/images/footerlogo.svg"
            alt=""
          />
          <img
            className="w-[240px] md:w-[300px] h-auto hidden dark:block"
            src="/images/footerlogo-dark.svg"
            alt=""
          />
        </div>
        <p className="text-[#797979] text-[12px] md:text-sm leading-[21px] font-semibold mt-[14px]">
          {t('footer.tagline')}
        </p>
        <p className="text-[#fbac40] text-[12px] md:text-sm leading-[21px] font-semibold mt-2 md:mt-[14px]">
          {t('footer.secureConnection')}
        </p>
        <p className="text-[#797979] text-[12px] md:text-sm leading-[21px] font-semibold mt-[14px]">
          <span className="text-[#fbac40]">{t('footer.bonusRuleLabel')}</span>{' '}
          {t('footer.bonusRuleText')}
        </p>
        <p className="text-[#797979] text-[12px] md:text-sm leading-[21px] font-semibold mt-[14px]">
          <span className="text-[#fbac40]">{t('footer.earlyWithdrawalLabel')}</span>{' '}
          {t('footer.earlyWithdrawalText')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
